import { useState } from "react";
import api from "../api/axios";

export default function useCreate(endpoint) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const create = async (data) => {
    setLoading(true);
    setErrors(null);

    try {
      const res = await api.post(endpoint, data);
      return res.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const backendErrors = {};
        error.response.data.errors.forEach((err) => {
          backendErrors[err.path || "general"] = err.msg;
        });
        setErrors(backendErrors);
        throw backendErrors;
      }

      throw { general: "Error inesperado" };
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, errors };
}
